var map = {
  "./_example/templates": "93987",
  "./config/templates": "11068",
  "./frontend/templates": "98718",
  "./help/templates": "67825",
  "./job/templates": "62943",
  "./modules/fulltext/templates": "49186",
  "./modules/gndo/templates": "64924",
  "./modules/presentation/templates": "25646",
  "./modules/qa/templates": "18738",
  "./modules/serverlog/templates": "4749",
  "./modules/stats/templates": "70089",
  "./modules/timeline/templates": "16023",
  "./widgets/templates": "28755",
  "./wiki/templates": "1864"
};


function __rspack_async_context(req) {
  return __rspack_async_context_resolve(req).then(__webpack_require__);
}
function __rspack_async_context_resolve(req) {
  return Promise.all(/* lazy-once context | core */ [__webpack_require__.e("rbush-node_modules_rbush_rbush_min_js"), __webpack_require__.e("vendors-node_modules_date-fns_esm_differenceInYears_index_js-node_modules_date-fns_esm_getDat-28ce70"), __webpack_require__.e("src_modules_serverlog_utils_js-src_tree_rules_js-src_viewer_layouts_js"), __webpack_require__.e("core")]).then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.resolve = __rspack_async_context_resolve;
__rspack_async_context.id = 56091;
module.exports = __rspack_async_context;
